import {Button} from '@freckle/educator-materials/ts/components/button'
import {Panel} from '@freckle/educator-materials/ts/components/panel'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import type {UnmanagedCourseT} from '@freckle/school/ts/common/models/unmanaged-course'
import {columns} from './course-summary.module.scss'

type Props = {
  courses: Array<UnmanagedCourseT>
  onReview: () => void
}

export function CourseSummary({courses, onReview}: Props) {
  const {t} = useSafeTranslation()
  return (
    <Panel headingTitle={t('COURSE_SUMMARY_PANEL_TITLE')}>
      <div className={columns}>
        <span>
          <SafeTrans i18nKey="COURSE_SUMMARY_DELETED_COUNT" values={{numCourses: courses.length}} />
        </span>
        <Button style="link" onClick={onReview}>
          {t('COURSE_SUMMARY_BUTTON_VIEW_DETAILS')}
        </Button>
      </div>
    </Panel>
  )
}
